import { render, staticRenderFns } from "./ResidenceItem.vue?vue&type=template&id=0803d28e&"
import script from "./ResidenceItem.vue?vue&type=script&lang=js&"
export * from "./ResidenceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0803d28e')) {
      api.createRecord('0803d28e', component.options)
    } else {
      api.reload('0803d28e', component.options)
    }
    module.hot.accept("./ResidenceItem.vue?vue&type=template&id=0803d28e&", function () {
      api.rerender('0803d28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceItem.vue"
export default component.exports